// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import CaretDown from "@vanmeter/XDL/Icons/IconCaretDown";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            width: 9,
            height: 13,
            color: "common.ui5",
            src: CaretDown,
            css: css`
                &&& {
                    background-color: transparent;
                    width: auto;
                }
            `,
        },
        css: css`
            cursor: pointer;
            &[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
                padding-left: 8px;
            }
            &&&&,
            &&&&:focus {
                padding-right: 24px;
                text-overflow: ellipsis;
            }
        `,
    },
} as xBaseTheme["select"];
